import { render, staticRenderFns } from "./fan-list-table.vue?vue&type=template&id=1a4ab5e6&"
import script from "./fan-list-table.vue?vue&type=script&lang=js&"
export * from "./fan-list-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports